import { setRecoil } from 'recoil-nexus'
import { BigNumber } from 'bignumber.js'
import { CairoVersion, ProviderInterface, RpcProvider, SequencerProvider } from 'starknet'
import { ToastMsg, toastsState } from '../atoms'
import { networkNameByChainId } from './wallet.service'
import { Network } from './token.service'
import { getRPCUrl, getStarknetChainIdFromNetwork } from '../blockchainUtils'
import { getTokenBalance } from '../model/tokens/helper'
import { decimal_int_to_float } from '../blockchainUtils/math'
import { getNetworkBaseUrl } from '../blockchainUtils/general'

export const getAMMContract = (networkName: string): string => {
    if (networkName?.includes('mainnet')) return '0x10884171baf1914edc28d7afb619b40a4051cfae78a094a55d230f19e944a28'
    return '0x018a439bcbb1b3535a6145c1dc9bc6366267d923f60a84bd0c7618f33c81d334'
}
export const ETH_TOKEN_ADDRESS = '0x49d36570d4e46f48e99674bd3fcc84644ddd6b96f7c741b1562b82f9e004dc7'
export const ETH_SWAP_MAX_ALLOWED = 10
export const DAI_TOKEN_ADDRESS = '0xda114221cb83fa859dbdb4c44beeaa0bb37c7537ad5ae66fe5e0efd20e6eb3'
export const USDT_TOKEN_ADDRESS = '0x68f5c6a61780768455de69077e07e89787839bf8166decfbf92b645209c0fb8'
export const ETH_TO_DAI_SWAP_MAX_ALLOWED = 10
export const ETH_TO_USDT_SWAP_MAX_ALLOWED = 10

// get Provider from OUR starknet.js,
// based on the baseUrl from the WALLET's starknet.js
export const getSequencerProvider = async (network?: Network): Promise<ProviderInterface> => {
    if (network) {
        const baseUrl = getNetworkBaseUrl(network)
        return new SequencerProvider({
            baseUrl
        })
    }

    const starknet = window.getStarknet?.()
    if (!starknet?.provider) {
        // disconnected, return default network
        return new SequencerProvider()
    }

    const chainId = await starknet.provider.getChainId()
    const walletNetwork = networkNameByChainId(chainId)
    const baseUrl = getNetworkBaseUrl(walletNetwork)

    return new SequencerProvider({ baseUrl })
}

let isProviderInitiated = false
// eslint-disable-next-line no-unused-vars
let rpcProviders: { [network in Network]?: ProviderInterface } = {}
// eslint-disable-next-line no-unused-vars
let sequencerProviders: { [network in Network]?: SequencerProvider } = {}
export async function initProvider(network: Network) {
    if ((network && (network === 'mainnet-alpha' || network === 'goerli-alpha')) || network === 'sepolia-alpha') {
        rpcProviders[network] = new RpcProvider({
            nodeUrl: getRPCUrl(network),
            chainId: getStarknetChainIdFromNetwork(network)
            // blockIdentifier: 457660
        } as any)
    }
    const baseUrl = getNetworkBaseUrl(network)
    sequencerProviders[network] = new SequencerProvider({ baseUrl })
    isProviderInitiated = true
}

export const getProvider = async (network: Network, forceSequencer: boolean = false): Promise<ProviderInterface> => {
    if (!sequencerProviders[network] || !rpcProviders[network]) {
        initProvider(network || 'mainnet-alpha')
    }

    if (!forceSequencer) {
        const provider = rpcProviders[network]
        if (provider !== undefined) {
            return provider
        }
    }

    const starknet = window.getStarknet?.()
    if (!starknet?.provider) {
        // starknet?.account
        console.log('NO STARKNET ')
        // const baseUrl = getNetworkBaseUrl(network)
        // return new SequencerProvider({ baseUrl })
        return new RpcProvider({
            nodeUrl: getRPCUrl(network),
            chainId: getStarknetChainIdFromNetwork(network)
            // blockIdentifier: 457660
        } as any)
    }
    // console.log('starknet?.account ', starknet?.account)

    return starknet!.provider as any
    // return sequencerProvider
}

export const onNetworkChange = async () => {}

export const getWalletTokenAmount = (network: string, token: string): string => {
    const balance = getTokenBalance(network, token)
    return decimal_int_to_float(network, token, balance)
}

export const addToastMsg = (msg: string, type: string) => {
    let t: ToastMsg = {
        msg: msg,
        type: type,
        dismiss: false,
        hash: BigNumber.random(10).times(1e10).toString(16)
    }
    setRecoil(toastsState, (current: Array<ToastMsg>) => {
        return [...current, t]
    })
}

export const walletAddress = () => {
    return window.getStarknet?.()?.selectedAddress ?? ''
}

export const accountCairoVersion = (): CairoVersion => {
    return window.getStarknet?.()?.cairoVersion ?? '0'
}

export const accountBraavosMultisig = (): boolean => {
    // return true
    return window.getStarknet?.()?.isMultisig ?? false
}

// fixme: probably redundant, consider remove
export const numberToCallParam = (n: number | string): string => {
    return new BigNumber(n).toString(10)
}
